import { concantQuery } from "@/utils/concatQuery";
import api from "./api";

/**
 * Get vdp-articles.
 * @param {*} param0
 * @returns
 */
const loadVdpArticles = ({ take, skip, search }) => {
  const query = concantQuery({ take, skip, search });
  return api.get(`/vdp-article${query}`);
};

/**
 * Add blog.
 * @param {*} param0
 * @returns
 */
const addVdpArticle = body => {
  return api.post("/vdp-article", body);
};

const updateVdpArticleState = data => {
  console.log("data",data)
  return api.put(`/vdp-article/state/${data.id}`, {state: data.value});
};

/**
 * Add vdp-article.
 * @param {*} param0
 * @returns
 */
const editVdpArticle = (blogId, body) => {
  return api.put(`/vdp-article/${blogId}`, body);
};

/**
 * Add vdp-article.
 * @param {*} param0
 * @returns
 */
const deleteVdpArticle = blogId => {
  return api.delete(`/vdp-article/${blogId}`);
};

/**
 * Get vdp-article.
 * @param {*} param0
 * @returns
 */
const uploadCoverImage = (body) => {
  return api.post('/vdp-article/uploads', body);
};

export { loadVdpArticles, addVdpArticle, editVdpArticle, deleteVdpArticle, uploadCoverImage, updateVdpArticleState };
